export const VERSION = '2.12.2';
